import { useQuery } from '@tanstack/react-query'
import { getAllAvailableEventLocations, getAvailableEventLocations, getEventLocationDetails } from 'api/event'

export const useEventLocationDetails = (id: string) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['event_locations', id],
        queryFn: () => getEventLocationDetails(id),
        enabled: !!id,
    })
    return { data, isLoading, error }
}

export const useAvailableEventLocations = () => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['event_locations'],
        queryFn: () => getAvailableEventLocations(null),
    })

    return {
        data,
        isLoading,
        error,
    }
}

export const useAllAvailableEventLocations = () => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['event_locations_all'],
        queryFn: () => getAllAvailableEventLocations(),
    })

    return {
        data,
        isLoading,
        error,
    }
}

export const useAvailableEventLocationsById = (eventId: string) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['event_locations', eventId],
        queryFn: () => getAvailableEventLocations(eventId),
        enabled: !!eventId,
    })

    return {
        data,
        isLoading,
        error,
    }
}
